import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(`relative overflow-hidden
    bg-gray-200 dark:bg-gray-500
    before:absolute before:inset-0
    before:animate-[shimmer_1.2s_linear_infinite]
    before:bg-gradient-to-r
    before:from-transparent
    before:via-white/60
    before:to-transparent`, className)}
      {...props}
    />
  )
}

export { Skeleton }
